import ContextTemplate from './context.template';

let initialState = { filterChart: [] };
const reducer = (prevState = initialState, action) => {
  switch (action.type) {
    case 'SET_FILTER':
      return { ...prevState, filterChart: action.payload };
    default:
      return prevState;
  }
};

const fetchFilterChart = (dispatch) => {
  return (payload) => {
    dispatch({ type: 'SET_FILTER', payload: payload });
  };
};

const action = { fetchFilterChart };

const [context, provider] = ContextTemplate(reducer, action, initialState);

export { context, provider };
